import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { Viol3ArbetsorderResponseDTO } from "~app/common/models/integration/viol3/Viol3ArbetsorderResponseDTO";
import { Viol3HistorikResponseDTO } from "~app/common/models/integration/viol3/Viol3HistorikResponseDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IntegrationService } from "../service/integration.service";
import { VirkesorderEventsViewModel } from "./virkesorder-historik.models";

@Component({
    selector: "rask-virkesorder-historik",
    templateUrl: "./virkesorder-historik.component.html",
    styleUrls: ["./virkesorder-historik.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        TogglePanelComponent,
        ListComponent,
        ListColumnDirective
    ]
})
export class VirkesorderHistorikComponent {
    eventsVievModel: VirkesorderEventsViewModel;
    @Input() selectedArbetsorder: Viol3ArbetsorderResponseDTO;

    private readonly busyService = inject(BusyService);
    private readonly integrationService = inject(IntegrationService);

    canGetHistorik() {
        return ObjectUtils.isNullOrUndefined(this.selectedArbetsorder);
    }

    hamtaHistorik() {
        const historik = this.integrationService.getVirkesorderHistorik(this.selectedArbetsorder.beteckning);

        this.busyService.addWork(historik).subscribe((res: Viol3HistorikResponseDTO) => {
            this.eventsVievModel = new VirkesorderEventsViewModel(res);
        });
    }
}
